module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p>You are currently not in any league, click here to view the \'<a href="/fantasy/league/join" title="Join a League">Join a League</a>\' page</p>';
}
return __p;
};
